const buildTaskSubmittedResult = (data) => {
  return {
    assetUrl: null,
    taskSubmitted: true,
    taskId: data.taskId,
    videoId: data.videoId,
    imageId: data.imageId,
    mediaType: data.mediaType || (data.imageId ? 'image' : 'video'),
    previewUrl: data.previewUrl,
    message: data.message,
    note: data.note,
    additionalInfo: {
      ...(data.additionalInfo || {}),
      taskSubmitted: true,
      taskId: data.taskId,
      videoId: data.videoId,
      imageId: data.imageId,
      mediaType: data.mediaType || (data.imageId ? 'image' : 'video'),
      provider: data.provider,
      modelName: data.modelName,
      model: data.model,
      previewUrl: data.previewUrl,
    },
  };
};

const buildTaskQueuedResult = (data) => {
  return {
    assetUrl: null,
    taskQueued: true,
    taskId: data.taskId || null,
    videoId: data.videoId,
    imageId: data.imageId,
    mediaType: data.mediaType || (data.imageId ? 'image' : 'video'),
    message: data.message,
    additionalInfo: {
      ...(data.additionalInfo || {}),
      taskQueued: true,
      taskId: data.taskId || null,
      videoId: data.videoId,
      imageId: data.imageId,
      mediaType: data.mediaType || (data.imageId ? 'image' : 'video'),
      provider: data.provider || null,
      status: 'queued',
    },
  };
};

const buildTaskPollingFailedResult = (data) => {
  return {
    assetUrl: null,
    taskPollingFailed: true,
    taskId: data.taskId,
    videoId: data.videoId,
    imageId: data.imageId,
    mediaType: data.mediaType || (data.imageId ? 'image' : 'video'),
    message: data.message,
    note: data.note,
    additionalInfo: {
      ...(data.additionalInfo || {}),
      taskPollingFailed: true,
      videoId: data.videoId,
      imageId: data.imageId,
      mediaType: data.mediaType || (data.imageId ? 'image' : 'video'),
      provider: data.provider,
      modelName: data.modelName,
      model: data.model,
      taskId: data.taskId,
      status: 'processing',
    },
  };
};

export function buildVideoGenerationResult(data) {
  if (data?.type === 'task_queued') {
    return buildTaskQueuedResult(data);
  }

  if (data?.type === 'task_submitted') {
    return buildTaskSubmittedResult(data);
  }

  if (data?.type === 'task_polling_failed') {
    return buildTaskPollingFailedResult(data);
  }

  return null;
}
